export default "__VITE_ASSET__lCaANPQz__"